import { useState, useEffect } from 'react';

const useUserLocation = () => {
  const [locationAllowed, setLocationAllowed] = useState(false);
  const [coords, setCoords] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [hasCheckedPermission, setHasCheckedPermission] = useState(false); // ✅ NEW

  const requestLocation = () => {
    if (!navigator.geolocation) {
      setLocationAllowed(false);
      setErrorMessage('Geolocation is not supported by your browser.');
      setHasCheckedPermission(true);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setCoords({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
        setLocationAllowed(true);
        setErrorMessage('');
        setHasCheckedPermission(true);
      },
      (error) => {
        setLocationAllowed(false);
        switch (error.code) {
          case 1:
            setErrorMessage('Location access is blocked. Please enable it in your browser settings.');
            break;
          case 2:
            setErrorMessage('Location is unavailable. Try again later.');
            break;
          case 3:
            setErrorMessage('Location request timed out. Try again.');
            break;
          default:
            setErrorMessage('An unknown error occurred.');
        }
        setHasCheckedPermission(true);
      }
    );
  };

  useEffect(() => {
    if (navigator.permissions) {
      navigator.permissions.query({ name: 'geolocation' }).then((result) => {
        if (result.state === 'denied') {
          setLocationAllowed(false);
          setErrorMessage('Location access is blocked. Please enable it in your browser settings.');
          setHasCheckedPermission(true);
        } else if (result.state === 'granted') {
          requestLocation(); // this will call setHasCheckedPermission later
        } else {
          setHasCheckedPermission(true);
        }
      });
    } else {
      setHasCheckedPermission(true); // fallback if permissions API is not supported
    }
  }, []);

  return { locationAllowed, coords, requestLocation, errorMessage, hasCheckedPermission };
};

export default useUserLocation;
